export default {
  name: "ReviewsSeoBlock",
  props: {
    info: {
      type: Object,
      required: true,
    }
  },
  methods: {
    goToCatalog() {
      this.$router.push(this.$localize({ name: "products" }));
    }
  }
}
